import React from 'react'
import Icon from 'antd/es/icon'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Grid from '@material-ui/core/Grid'
import { Link as RouterLink } from 'react-router-dom'
import DeleteIcon from "@material-ui/icons/Delete"
import IconButton from '@material-ui/core/IconButton'
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline"

// START - columns for tables RejectedByAp
export const RejectedByAp = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '35px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: '#',
            selector: 'id',
            width: '70px',
            sortable: true,
            cell: row => row.id
        },
        // {
        //     name: 'Número de la PO',
        //     selector: 'poNumber',
        //     width: '170px',
        //     sortable: true,
        //     cell: row => row.poNumber
        // },
        {
            name: 'Número de orden',
            selector: 'orderNumber',
            width: '170px',
            sortable: true,
            cell: row => row.orderNumber
        },
        {
            name: 'Entidad',
            width: '150px',
            selector: 'entity',
            sortable: true,
            cell: row => row.entity
        },
        {
            name: 'Centro de Costo',
            selector: 'costoCenter',
            sortable: true,
        },
        {
            name: 'Descripción',
            selector: 'description',
            width: '170px',
            sortable: true,
            cell: row => row.description
        },
        {
            name: 'Proveedor',
            selector: 'supplierName',
            sortable: true,
            width: '220px',
            cell: row => row.supplierId === 0 ? showButtonAddSupplier(row) : row.supplierName
        },
        {
            name: 'Monto',
            selector: 'amountText',
            sortable: true,
            width: '120px',
            cell: row => row.amountText
        },
        {
            name: 'Moneda',
            selector: 'currencyId',
            width: '80px',
            sortable: true,
            cell: row => row.currencyId === 1 ? 'USD' : 'MXN'
        },
        {
            name: 'Fecha de creacion',
            selector: 'createDate',
            width: '160px',
            sortable: true,
            cell: row => row.createDate
        },
        {
            name: 'Vigencia de PO',
            selector: 'maturity',
            width: '90px',
            sortable: true,
            cell: row => row.maturity
        },
        {
            name: 'Estatus de Factura',
            selector: 'invoiceStatus',
            width: '110px',
            sortable: true,
            cell: row => (showStatusInvoiceText(row.invoiceStatus))
        },
        {
            name: 'Días de atraso de factura',
            width: '120px',
            cell: row => (showTrafficLightsWithOutInvoice(row))
        },
        {
            name: 'Opciones',
            width: '170px',
            center: true,
            cell: row => (showButtonUploadInvoce(row))
        }
    ]
)

// START - columns for tables WithoutInvoice
export const WithoutInvoice = (
    [
        {
            name: '#',
            selector: 'id',
            width: '70px',
            sortable: true,
            cell: row => row.id
        },
        {
            name: 'Número de orden',
            selector: 'orderNumber',
            width: '170px',
            sortable: true,
            cell: row => row.orderNumber
        },
        {
            name: 'Entidad',
            width: '150px',
            selector: 'entity',
            sortable: true,
            cell: row => row.entity
        },
        {
            name: 'Centro de Costo',
            selector: 'costoCenter',
            sortable: true,
        },
        {
            name: 'Descripción',
            selector: 'description',
            width: '170px',
            sortable: true,
            cell: row => row.description
        },
        {
            name: 'Proveedor',
            selector: 'supplierName',
            sortable: true,
            width: '220px',
            cell: row => row.supplierId === 0 ? showButtonAddSupplier(row) : row.supplierName
        },
        {
            name: 'Monto',
            selector: 'amountText',
            sortable: true,
            width: '120px',
            cell: row => row.amountText
        },
        {
            name: 'Moneda',
            selector: 'currencyId',
            width: '80px',
            sortable: true,
            cell: row => row.currencyId === 1 ? 'USD' : 'MXN'
        },
        {
            name: 'Fecha de creacion',
            selector: 'createDate',
            width: '160px',
            sortable: true,
            cell: row => row.createDate
        },
        {
            name: 'Vigencia de PO',
            selector: 'maturity',
            width: '90px',
            sortable: true,
            cell: row => row.maturity
        },
        {
            name: 'Estatus de Factura',
            selector: 'invoiceStatus',
            width: '110px',
            sortable: true,
            cell: row => (showStatusInvoiceText(row.invoiceStatus))
        },
        {
            name: 'Días de atraso de factura',
            width: '120px',
            cell: row => (showTrafficLightsWithOutInvoice(row))
        },
        {
            name: 'Opciones',
            width: '170px',
            center: true,
            cell: row => (showButtonUploadInvoce(row))
        }
    ]
)

const showButtonUploadInvoce = (row) => {
    return (
        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
            <Button type="button" variant="outlined" component={RouterLink} to={`/indirect/UploadInvoice/${row.id}`}>Subir Factura</Button>
        </ButtonGroup>
    )
}

const showStatusInvoiceText = (invoiceStatus) => {
    switch (invoiceStatus) {
        case (0):
            return ('Sin Factura')
        case (17):
            return ('Factura Recibida')
        case (25):
            return ('Rechazada por AP')
        case (27):
            return ('Pendiente de Pago')
        case (28):
            return ('Pagada')
        case (29):
            return ('Pagada Parcialmente')
        case (31):
            return ('En Propuesta de Pago')
        default:
            break;
    }
}

// START - columns for tables with WithInvoice 
export const WithInvoice = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '35px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: '#',
            width: '70px',
            selector: 'poIdentifier',
            sortable: true,
            cell: row => row.poIdentifier
        },
        // {
        //     name: 'Número de la PO',
        //     width: '170px',
        //     selector: 'poNumber',
        //     sortable: true,
        //     cell: row => row.poNumber
        // },
        {
            name: 'Número de orden',
            selector: 'orderNumber',
            width: '170px',
            sortable: true,
            cell: row => row.orderNumber
        },
        {
            name: 'Entidad',
            width: '150px',
            selector: 'entity',
            sortable: true,
            cell: row => row.entity
        },
        {
            name: 'Centro de Costo',
            selector: 'costoCenter',
            sortable: true,
        },
        {
            name: 'Descripción',
            selector: 'description',
            width: '170px',
            sortable: true,
            cell: row => row.description
        },
        {
            name: 'Proveedor',
            selector: 'supplierName',
            sortable: true,
            width: '220px',
            cell: row => row.supplierId === 0 ? showButtonAddSupplier(row) : row.supplierName
        },
        {
            name: 'Monto',
            selector: 'amountText',
            sortable: true,
            width: '120px',
            cell: row => row.amountText
        },
        {
            name: 'Moneda',
            width: '80px',
            selector: 'currency',
            sortable: true,
            cell: row => row.currencyId === 1 ? 'USD' : 'MXN'
        },
        {
            name: 'Fecha de creacion',
            selector: 'createDate',
            width: '160px',
            sortable: true,
            cell: row => row.createDate
        },
        {
            name: 'Vigencia de PO',
            width: '90px',
            selector: 'maturity',
            sortable: true,
            cell: row => row.maturity
        },
        {
            name: 'Estatus de Factura',
            width: '130px',
            selector: 'invoiceStatus',
            sortable: true,
            cell: row => (showStatusInvoiceText(row.invoiceStatus))
        },
        {
            name: 'Días de atraso de factura',
            width: '140px',
            cell: row => (showTrafficLightsWithOutInvoiceComplete(row))
        }

    ]
)

// START - columns for tables Unpaid
export const Unpaid = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '35px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: '#',
            width: '70px',
            selector: 'poIdentifier',
            sortable: true,
            cell: row => row.poIdentifier
        },
        {
            name: 'Número de orden',
            selector: 'orderNumber',
            width: '170px',
            sortable: true,
            cell: row => row.orderNumber
        },
        // {
        //     name: 'Número de la PO',
        //     selector: 'poNumber',
        //     width: '170px',
        //     sortable: true,
        //     cell: row => row.poNumber
        // },
        {
            name: 'Entidad',
            width: '150px',
            selector: 'entity',
            sortable: true,
            cell: row => row.entity
        },
        {
            name: 'Centro de Costo',
            selector: 'costoCenter',
            sortable: true,
        },
        {
            name: 'Descripción',
            selector: 'description',
            width: '170px',
            sortable: true,
            cell: row => row.description
        },
        {
            name: 'Proveedor',
            selector: 'supplierName',
            sortable: true,
            width: '220px',
            cell: row => row.supplierId === 0 ? showButtonAddSupplier(row) : row.supplierName
        },
        {
            name: 'Monto',
            selector: 'amountText',
            sortable: true,
            width: '120px',
            cell: row => row.amountText
        },
        {
            name: 'Moneda',
            width: '80px',
            selector: 'currency',
            sortable: true,
            cell: row => row.currencyId === 1 ? 'USD' : 'MXN'
        },
        {
            name: 'Fecha de creacion',
            selector: 'createDate',
            width: '160px',
            sortable: true,
            cell: row => row.createDate
        },
        {
            name: 'Vigencia de PO',
            selector: 'maturity',
            width: '90px',
            sortable: true,
            cell: row => row.maturity
        },
        {
            name: 'Estatus de Factura',
            selector: 'invoiceStatus',
            width: '110px',
            sortable: true,
            cell: row => (showStatusInvoiceText(row.invoiceStatus))
        },
        {
            name: 'Días de atraso',
            width: '140px',
            cell: row => (showTrafficLightsWithOutInvoiceComplete(row))
        },
        {
            name: 'Opciones',
            width: '210px',
            center: true,
            cell: row => (showButtonUploadComplement(row))
        }
    ]
)

const showButtonUploadComplement = (row) => {
    return (
        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
            <Button type="button" variant="outlined" component={RouterLink} to={`/indirect/UploadComplement/${row.id}`}>Subir Complemento</Button>
        </ButtonGroup>
    )
}

const showTrafficLightsWithOutInvoiceComplete = (row) => {
    return (
        <Grid container item xs={12}>
            <Grid item xs={4}>
                <div style={circleStyleBack}></div>
            </Grid>
            <Grid item xs={8}>
                <label>Completado</label>
            </Grid>
        </Grid>
    )
}

const showTrafficLightsWithOutInvoice = (row) => {
    let text = ''
    row.lagTime <= 30 ? text = '30 días' : text = '+30 días'

    return (
        <Grid container item xs={12}>
            <Grid item xs={4}>
                <div style={circleStyleGreen}></div>
            </Grid>
            <Grid item xs={8}>
                <label>{text}</label>
            </Grid>
        </Grid>
    )

}

const showButtonAddSupplier = (row) => {
    return (
        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
            <Button type="button" variant="outlined" component={RouterLink} to={`/indirect/AssingSupplier/${row.id}`}>Asignar proveedor</Button>
        </ButtonGroup>
    )
}

const circleStyleGreen = {
    padding: 5,
    display: "inline-block",
    backgroundColor: "#2DCB09",
    borderRadius: "100%",
    width: 25,
    height: 25,
}

const circleStyleBack = {
    padding: 5,
    display: "inline-block",
    backgroundColor: "#ded8d6",
    borderRadius: "100%",
    width: 25,
    height: 25,
}

// START - columns for tables with paid 
export const Paid = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '35px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: '#',
            width: '70px',
            selector: 'poIdentifier',
            sortable: true,
        },
        // {
        //     name: 'Número de la PO',
        //     width: '170px',
        //     selector: 'poNumber',
        //     sortable: true,
        // },
        {
            name: 'Número de orden',
            selector: 'orderNumber',
            width: '170px',
            sortable: true,
            cell: row => row.orderNumber
        },
        {
            name: 'Entidad',
            width: '150px',
            selector: 'entity',
            sortable: true,
        },
        {
            name: 'Centro de Costo',
            selector: 'costoCenter',
            sortable: true,
        },
        {
            name: 'Descripción',
            selector: 'description',
            width: '170px',
            sortable: true,
            cell: row => row.description
        },
        {
            name: 'Proveedor',
            selector: 'supplierName',
            sortable: true,
            width: '220px',
            cell: row => row.supplierId === 0 ? showButtonAddSupplier(row) : row.supplierName
        },
        {
            name: 'Monto',
            selector: 'amountText',
            sortable: true,
            width: '120px',
        },
        {
            name: 'Moneda',
            width: '80px',
            selector: 'currency',
            sortable: true,
            cell: row => row.currencyId === 1 ? 'USD' : 'MXN'
        },
        {
            name: 'Fecha de creacion',
            selector: 'createDate',
            width: '160px',
            sortable: true,
            cell: row => row.createDate
        },
        {
            name: 'Vigencia de PO',
            width: '90px',
            selector: 'maturity',
            sortable: true,
        },
        {
            name: 'Estatus de Factura',
            width: '130px',
            selector: 'invoiceStatus',
            sortable: true,
            cell: row => (showStatusInvoiceText(row.invoiceStatus))
        },
        {
            name: 'Días de atraso de factura',
            width: '140px',
            cell: row => (showTrafficLightsWithOutInvoiceComplete(row))
        }

    ]
)

//column for historical table
export const ColumnsForInvoiceHistorical = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '40px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Factura',
            selector: 'nameInvoice',
            sortable: true,
            cell: row => row.nameInvoice
        },
        {
            name: 'Fecha',
            width: '200px',
            selector: 'date',
            sortable: true,
            cell: row => row.date
        },
        {
            name: 'Mensaje',
            selector: 'message',
            sortable: true,
            width: '300px',
            cell: row => row.message
        }
    ]
)

//column for RejectedInvoces
export const ColumnsForRejectesInvoice = ({ DeleteRejectedInvoice }) => (
    [
        {
            name: 'Eliminar',
            width: '90px',
            center: true,
            cell: row => (showButtonDeleteRejectesInvoice(row, { DeleteRejectedInvoice }))
        },
        {
            name: 'Folio',
            selector: 'folio',
            sortable: true,
            cell: row => row.folio
        }
    ]
)

const showButtonDeleteRejectesInvoice = (row, { DeleteRejectedInvoice }) => {
    return (
        <IconButton aria-label="delete" style={{ color: '#C22727' }} title="Eliminar" onClick={() => DeleteRejectedInvoice(row.idInvoice)}>
            <DeleteIcon />
        </IconButton>
    )
}

//column for InvoiceComplement
export const ColumnsForInvoiceComplement = (
    [
        {
            cell: () => <Icon type='bars' style={{ fill: '#43a047' }} theme="outlined" />,
            width: '56px',
            style: {
                color: '#43a047'
            }
        },
        {
            name: 'Factura',
            selector: 'nameInvoice',
            sortable: true,
            width: '320px',
            cell: row => row.nameInvoice
        },
        {
            name: 'Monto de la factura',
            selector: 'totalAmount',
            sortable: true,
            width: '130px',
            cell: row => row.totalAmount
        },
        {
            name: 'Complementos cargados',
            selector: 'complements',
            sortable: true,
            width: '150px',
            cell: row => showComplementList(row.complements)
        },
        {
            name: 'Complemento',
            selector: 'statusComplement',
            sortable: true,
            width: '130px',
            center: true,
            cell: row => (showIconProcessFinished(row))
        }
    ]
)

const showComplementList = (complements) => {
    return (
        <div>
            {
                complements && (
                    complements.map((item, index) => {
                        return (
                            <Grid item xs={12} key={index}>
                                <Grid container item xs={12}>
                                    <Grid item xs={12}>
                                        {item.amountPaid}
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    }
                    )
                )
            }

        </div>
    )
}

const showIconProcessFinished = (row) => {
    if (row.statusComplement) {
        return (
            <Grid container item xs={12} style={{ textAlign: 'center' }}>
                <Grid item xs={12}>
                    <CheckCircleIcon style={{ color: 'green', fontSize: "1rem" }} />
                </Grid>
            </Grid>
        )
    } else {
        return (
            <Grid container item xs={12} style={{ textAlign: 'center' }}>
                <Grid item xs={12}>
                    <ErrorOutlineIcon style={{ color: '#FFAB00', fontSize: "1rem" }} />
                </Grid>
            </Grid>
        )
    }
}